var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"outlined":"","small":_vm.btnSmall,"block":_vm.btnBlock,"to":_vm.url,"color":"primary"}},[_vm._v("\n  Enviar mensagem\n")])}
var staticRenderFns = []

export { render, staticRenderFns }